import Vue from 'vue';
import App from './App.vue';
import { registerMicroApps, start } from 'qiankun';
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
registerMicroApps(
  [
    {
      name: 'micro-util',
      entry: '//localhost:3002',
      container: '#app',
      activeRule: '/micro-util',
    },
  ],
  {
    // qiankun 生命周期钩子 - 微应用加载前
    beforeLoad: (app) => {
      console.log('before load', app.name);
      return Promise.resolve();
    },
    // qiankun 生命周期钩子 - 微应用挂载后
    afterMount: (app) => {
      console.log('after mount', app.name);
      return Promise.resolve();
    },
  }
);
start();
